var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blue-wrap"},[_c('div',{staticClass:"blue-title"},[_vm._v("马上了解睿泽，让您的公司管理更便捷、更高效、更智能")]),_vm._v(" "),_c('div',{staticClass:"blue-button"},[_c('div',{staticClass:"blue-btn row-center"},[_c('router-link',{staticClass:"wk-blue-btn",attrs:{"to":"/products"}},[_vm._v("立即了解睿泽")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-591f9cd5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/understand.vue
// module id = null
// module chunks = 